import React from 'react';
import {injectIntl} from 'react-intl';
import {Redirect} from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';

import API from '../../common/utils/API';
import {formatErrorMessageFromAPI} from '../../common/utils/helpers';
import Form from '../../components/form/countries/CountryForm';

export class CreateCountry extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // Redirects
            shouldRedirectToIndex: false,

            // Errors
            errorMessage: '',

            // Loading
            loading: false,
        };
    }

    onSubmit = async (input) => {
        this.setState({loading: true});

        try {
            await API.countries.save(input);

            this.setState({loading: false, shouldRedirectToIndex: true});
        } catch (e) {
            const error = formatErrorMessageFromAPI(
                e,
                this.props.intl.formatMessage({
                    id: 'ERROR_PAGES.STORING_DATA',
                }),
            );

            this.setState({
                ...error,
            });
        }
    };

    render() {
        const {shouldRedirectToIndex} = this.state;
        const initialValues = {
            name: '',
            code: '',
        };

        return shouldRedirectToIndex ? (
            <Redirect
                data-test='redirectToIndex'
                to={{
                    pathname: '/countries',
                    state: {
                        successMessage: this.props.intl.formatMessage({
                            id:
                                'COUNTRIES.COUNTRY_SUCCESSFULLY_CREATED_MESSAGE',
                        }),
                    },
                }}
            />
        ) : (
            <>
                <Alert
                    variant='danger'
                    className='mb-4'
                    show={!!this.state.errorMessage}
                >
                    <p className='mb-0'>{this.state.errorMessage}</p>
                </Alert>
                <Form
                    data-test='createCountryComponent'
                    initialValues={initialValues}
                    backRedirectUrl='/countries'
                    backText={this.props.intl.formatMessage({
                        id: 'LIST.BACK_TO_LIST',
                    })}
                    loading={this.state.loading}
                    handleSubmit={this.onSubmit}
                />
            </>
        );
    }
}

export default injectIntl(CreateCountry);
